interface CourseData {
  courseCode: string;
  courseName: string;
  courseDescr: string;
  coursePrereqs: string[];
  courseCoreqs: string[];
  courseOptPrereqs: string[];
  courseRelated: string[];
  courseIsKernel: boolean;
  courseAreas: number[] | null;
  //the following must be initialized after all other properties
  courseLeadsTo: string[] | null;
  courseRank: number | null;
  courseHeatmapAreas: HeatmapInstance[] | null;
  prerequisite: string | null;
  recommendedPreparation: string | null;
  exclusions: string | null;
  comments: string | null;
  corequisite: string | null;
}

interface HeatmapArea {
  areaName: string;
  areaIcon: string;
  areaDescription: string;
  areaIndex: number;
}

interface HeatmapInstance {
  heatmapArea: HeatmapArea;
  relevance: number; //from 0 to 3?
}

//deprecated
interface IConnectorData {
  sourceCode: string; //courseCode
  destCode: string;
}

export enum ConnectorType {
  PREREQ,
  COREQ,
  OPTPREREQ,
  RELATION,
}

export type { CourseData, HeatmapArea, HeatmapInstance, IConnectorData };
